<template>
    <div>
        <strong>Pertanyaan dipilih:</strong> {{ selectedQuestions.length }} |

        <span
            v-for="(count, idx) in selectedPerField"
            :key="idx"
        >
            <strong>{{ idx }}:</strong> {{ count }} |
        </span>
    </div>
</template>

<script>
export default {
    props: {
        selectedQuestions: {
            type: Array
        }
    },

    computed: {
        selectedPerField() {
            const fields = {}

            for (const question of this.selectedQuestions) {
                const field = question.field.title

                if (! fields[field]) {
                    fields[field] = 0
                }

                fields[field]++
            }

            return fields
        }
    }
}
</script>
